/** This file was generated by generateCatalogTranslation.js script. */

import Locale from '../../utils/Locale';

export function getCatalogTranslation(key:string) {
    switch (key) {
    case "Address": return Locale.gettext("Address");
    case "HUA": return Locale.gettext("HUA");
    case "Modbus Address": return Locale.gettext("Modbus Address");
    case "Brightness": return Locale.gettext("Brightness");
    case "Red": return Locale.gettext("Red");
    case "Green": return Locale.gettext("Green");
    case "Blue": return Locale.gettext("Blue");
    case "Red Light": return Locale.gettext("Red Light");
    case "Green Light": return Locale.gettext("Green Light");
    case "Blue Light": return Locale.gettext("Blue Light");
    case "Master Intensity": return Locale.gettext("Master Intensity");
    case "Twinkle Wheel": return Locale.gettext("Twinkle Wheel");
    case "Node ID": return Locale.gettext("Node ID");
    case "Zone": return Locale.gettext("Zone");
    case "White": return Locale.gettext("White");
    case "White Light": return Locale.gettext("White Light");
    case "Slave Id": return Locale.gettext("Slave Id");
    case "RS485 Address": return Locale.gettext("RS485 Address");
    case "UA": return Locale.gettext("UA");
    default: return key;
    }
}
